exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.message {\n    background-color: #00194e;\n    border: 1px solid #e7eaec;\n    text-align: left;\n    display: block;\n    padding: 10px 20px;\n    position: relative;\n    border-radius: 4px;\n}\n", ""]);

// exports
